import dayjs from "utils/dayjs";

export const dateFormatter = (date: Date | string | null | undefined) =>
  date ? new Date(date).toLocaleDateString() : "-";

export const dateFormatterUTC = (date: Date | string | null | undefined) =>
  date ? dayjs.tz(date).format("MM/DD/YYYY") : "-";
